import { Component, Input } from '@angular/core';
import { Relatorios } from '@modulos/home/submodulos/dados-meteorologicos/interfaces/tabela-relatorio';
import { ADTColumns } from 'angular-datatables/src/models/settings';
import { capitalizeFirstLetter, numberToBrNumberTables, renderCoordenada } from '@utils';

interface Meses {
	jan?: number | null;
	fev?: number | null;
	mar?: number | null;
	abr?: number | null;
	mai?: number | null;
	jun?: number | null;
	jul?: number | null;
	ago?: number | null;
	set?: number | null;
	out?: number | null;
	nov?: number | null;
	dez?: number | null;
}

export interface DadoPrecipitacaoMensal extends Meses {
	ano: number;
	total: number;
	latitude?: number;
	longitude?: number;
	altitude?: number;
	microrregiao?: string;
	mesorregiao?: string;
	regiao?: string;
	bacia?: string;
	[key: string]: any;
}

export interface DadoEstatisticaMensal extends Meses {
	estatistica: string;
}

@Component({
	selector: 'seira-tabela-relatorio-pluv-mensal-personalizada',
	templateUrl: './tabela-relatorio-pluv-mensal-personalizada.component.html',
	styleUrls: ['./tabela-relatorio-pluv-mensal-personalizada.component.scss'],
})
export class TabelaRelatorioPluvMensalPersonalizadaComponent {
	@Input() precipitacaoMensal: Relatorios<DadoPrecipitacaoMensal>[] = [];
	@Input() estatisticas: Relatorios<DadoEstatisticaMensal>[] = [];
	@Input() exibirEstatisticas = true;

	private _colunasSelecionadas: string[] = [];

	@Input()
	set colunasSelecionadas(val: string[]) {
		this._colunasSelecionadas = val || [];
		this.definirColunasTabelaPrecipitacaoMensal();
	}
	get colunasSelecionadas(): string[] {
		return this._colunasSelecionadas;
	}

	colunasPrecipitacaoMensal: ADTColumns[] = [];
	colunasEstatisticas: ADTColumns[] = [];

	constructor() {
		this.definirColunasTabelaPrecipitacaoMensal();
		this.definirColunasTabelaEstatisticas();
	}

	definirColunasTabelaPrecipitacaoMensal() {
		const cols: ADTColumns[] = [];

		if (this.colunasSelecionadas.includes('Latitude')) {
			cols.push({
				data: 'latitude',
				title: 'Latitude',
				type: 'number',
				className: 'text-center',
				render: (value: string) => renderCoordenada(value),
			});
		}
		if (this.colunasSelecionadas.includes('Longitude')) {
			cols.push({
				data: 'longitude',
				title: 'Longitude',
				type: 'number',
				className: 'text-center',
				render: (value: string) => renderCoordenada(value),
			});
		}
		if (this.colunasSelecionadas.includes('Altitude')) {
			cols.push({
				data: 'altitude',
				title: 'Altitude',
				type: 'number',
				className: 'text-center',
				render: (value: string) => renderCoordenada(value, 1),
			});
		}
		if (this.colunasSelecionadas.includes('Microrregião')) {
			cols.push({
				data: 'microrregiao',
				title: 'Microrregião',
				type: 'string',
				className: 'text-center',
			});
		}
		if (this.colunasSelecionadas.includes('Mesorregião')) {
			cols.push({
				data: 'mesorregiao',
				title: 'Mesorregião',
				type: 'string',
				className: 'text-center',
			});
		}
		if (this.colunasSelecionadas.includes('Região Pluviométrica')) {
			cols.push({
				data: 'regiao',
				title: 'Região Pluviométrica',
				type: 'string',
				className: 'text-center',
			});
		}
		if (this.colunasSelecionadas.includes('Bacia/Sub-bacia')) {
			cols.push({
				data: 'bacia',
				title: 'Bacia/Sub-bacia',
				type: 'string',
				className: 'text-center',
			});
		}

		cols.push({
			data: 'ano',
			title: 'Data',
			type: 'number',
			className: 'text-center',
		});

		const colunas = [
			'jan',
			'fev',
			'mar',
			'abr',
			'mai',
			'jun',
			'jul',
			'ago',
			'set',
			'out',
			'nov',
			'dez',
			'total',
		];
		colunas.forEach(coluna => {
			cols.push({
				data: coluna,
				title: capitalizeFirstLetter(coluna),
				type: 'number',
				className: 'text-center',
				render: valor => numberToBrNumberTables(valor, 1),
			});
		});

		this.colunasPrecipitacaoMensal = cols;
	}

	definirColunasTabelaEstatisticas() {
		const colunas = [
			'jan',
			'fev',
			'mar',
			'abr',
			'mai',
			'jun',
			'jul',
			'ago',
			'set',
			'out',
			'nov',
			'dez',
		];
		this.colunasEstatisticas.push({
			data: 'estatistica',
			title: 'Estatística',
			type: 'string',
			className: 'text-center',
		});
		colunas.forEach(coluna => {
			this.colunasEstatisticas.push({
				data: coluna,
				title: capitalizeFirstLetter(coluna),
				type: 'number',
				className: 'text-center',
				render: valor => numberToBrNumberTables(valor, 1),
			});
		});
		// Coluna adicional para espaçamento
		/*
		this.colunasEstatisticas.push({
			data: null,
			title: '',
			type: 'string',
			render: () => '<div style="padding-left: 2.7rem"></div>',
		});
    */
	}

	getEstatisticaMunicipio(municipio: string): DadoEstatisticaMensal[] {
		const relatorio = this.estatisticas.find(
			rel => rel.municipio === municipio
		);
		return relatorio ? relatorio.data : [];
	}
}
